import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Datatable from '../../../components/Datatable/';

import {
  getAllOccurrences,
  removeOccurrences,
  restoreOccurrences
} from '../../../redux/actions/occurrences';
import { getAllDepartments } from '../../../redux/actions/departments';
import { getAllTypeOccurrences } from '../../../redux/actions/typeOccurrences';
import { getAllClients } from '../../../redux/actions/clients';
import { getAllPets } from '../../../redux/actions/pets';
import TableHeader from '../../../components/TableHeader';
import ModalRemoveItem from '../../../components/ModalRemoveItem';
import ModalRestoreItem from '../../../components/ModalRestoreItem';
import translateSeverityOccurrence from '../../../utils/translateSeverityOccurrence';

import PageAddOccurrence from './Add';
import PageEditOccurrence from './Edit';

const ModalAddOccurrence = props => {
  const { handleModalClose, showModal, data } = props;

  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={showModal}
        onHide={handleModalClose}
        animation={true}
      >
        <Modal.Body>
          <PageAddOccurrence
            handleModalClose={handleModalClose}
            data={data || {}}
          />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalAddOccurrence.propTypes = {
  handleModalClose: PropTypes.func,
  showModal: PropTypes.bool,
  data: PropTypes.object
};

const ModalEditOccurrence = props => {
  const { handleModalClose, showModal, match } = props;

  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={showModal}
        onHide={handleModalClose}
        animation={true}
      >
        <Modal.Body>
          <PageEditOccurrence
            handleModalClose={handleModalClose}
            match={match || { params: { id: '' } }}
          />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalEditOccurrence.propTypes = {
  handleModalClose: PropTypes.func,
  showModal: PropTypes.bool,
  match: PropTypes.object
};

function List (props) {
  const { pet } = props;
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const occurrences = useSelector(state => state.occurrences);
  const dispatch = useDispatch();
  const users = useSelector(state => state.users.data);
  const authentications = useSelector(state => state.authentications);
  const tableData = occurrences.data
    .map(item => {
      const employees = users
        .filter(user => item.employees.includes(user._id))
        .map(user => user.name);
      return pet &&
        item.pets.includes(pet._id) &&
        (item.active || authentications.user.type === 'M')
        ? { ...item, employees }
        : false;
    })
    .filter(item => !!item);
  const [showModalRemove, setShowModalRemove] = useState(false);
  const [idItemWillRemove, setIdItemWillRemove] = useState('');
  const [nameItemWillRemove, setNameItemWillRemove] = useState('');
  const handleModalConfirmYesRemove = id => {
    setShowModalRemove(false);
    dispatch(removeOccurrences(id));
  };
  const [showModalRestore, setShowModalRestore] = useState(false);
  const [idItemWillRestore, setIdItemWillRestore] = useState('');
  const [nameItemWillRestore, setNameItemWillRestore] = useState('');
  const handleModalConfirmYesRestore = id => {
    setShowModalRestore(false);
    dispatch(restoreOccurrences({ _id: id, active: true }));
  };
  const [showModalEditOccurrence, setShowModalEditOccurrence] = useState(false);
  const [dataItemEditOccurrence, setDataItemWillEditOccurrence] = useState({});
  const [showModalAddOccurrence, setShowModalAddOccurrence] = useState(false);

  useEffect(() => {
    dispatch(getAllOccurrences({ company }));
    dispatch(getAllPets({ company }));
    dispatch(getAllDepartments());
    dispatch(getAllTypeOccurrences({ company }));
    dispatch(getAllClients({ company }));
  }, [dispatch]);

  const columns = [
    {
      title: 'Data e Hora',
      data: 'date',
      render: data => new Date(data).toLocaleString() || '---'
    },
    {
      title: 'Departamento',
      data: 'department.name',
      render: data => data || '---'
    },
    {
      title: 'Tipo',
      data: 'typeOccurrence.classification',
      render: (data, type, obj) => {
        if (data) {
          const { name, classification } = obj.typeOccurrence;
          const levelTranslated = translateSeverityOccurrence(classification);
          return `${name} - ${levelTranslated}`;
        } else {
          return '---';
        }
      }
    },
    {
      title: 'Colaboradores',
      data: 'employees',
      render: data => (data ? data.join(', ') : '---')
    },
    {
      title: 'Descrição',
      data: 'description',
      render: data => data || '---'
    },
    {
      title: 'Ações',
      data: '_id',
      orderable: false,
      className: 'no-export',
      render: (data, type, obj) => {
        return `
          <div class="btn-group">
            <button id="${data}" type="button" title="Editar" class="btn btn-warning button-action button-action-update rounded"><i class="fa fa-edit"></i></button>
            ${
              !obj.active
                ? ''
                : `<button id="${data}" type="button" title="Excluir" class="btn btn-danger button-action button-action-delete m-1 rounded"><i class="fa fa-trash"></i></button>`
            }
            ${
              obj.active
                ? ''
                : `<button id="${data}" type="button" title="Restaurar" class="btn btn-info button-action button-action-restore m-1 rounded"><i class="fas fa-trash-restore-alt"></i></button>`
            }
          </div>`;
      }
    }
  ];

  const buttons = [
    {
      extend: 'copy',
      className: 'btn btn-dark fa fa-copy',
      title: 'Relatorio Copiado',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'excel',
      className: 'btn btn-dark fa fa-file-excel',
      title: 'Relatorio Excel',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'csv',
      className: 'btn btn-dark fa fa-file-csv',
      title: 'Relatorio CSV',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'pdf',
      className: 'btn btn-dark fa fa-file-pdf',
      title: 'Relatorio PDF',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'print',
      className: 'btn btn-dark fa fa-file',
      title: 'Relatorio Print',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    }
  ];

  const handleUpdateButton = id => {
    const match = {
      params: {
        id
      }
    };
    setDataItemWillEditOccurrence(match);
    setShowModalEditOccurrence(true);
  };

  const handleDeleteButton = dataRow => {
    setNameItemWillRemove(new Date(dataRow.date).toLocaleString());
    setIdItemWillRemove(dataRow._id);
    setShowModalRemove(true);
  };

  const handleRestoreButton = dataRow => {
    setNameItemWillRestore(new Date(dataRow.date).toLocaleString());
    setIdItemWillRestore(dataRow._id);
    setShowModalRestore(true);
  };

  return (
    <div>
      <div className="mb-1">
        <button
          type="button"
          className="btn btn-success"
          disabled={showModalAddOccurrence}
          onClick={() => setShowModalAddOccurrence(true)}
        >
          <i className="fa fa-plus" />
          &nbsp;Ocorrência
        </button>
      </div>
      <ModalRemoveItem
        showModal={showModalRemove}
        handleModalClose={() => setShowModalRemove(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRemove(idItemWillRemove)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja excluir a ocorrência'}
        nameItemWillRemove={nameItemWillRemove}
      />
      <ModalRestoreItem
        showModal={showModalRestore}
        handleModalClose={() => setShowModalRestore(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRestore(idItemWillRestore)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja restaurar a ocorrência'}
        nameItemWillRestore={nameItemWillRestore}
      />
      <ModalEditOccurrence
        showModal={showModalEditOccurrence}
        handleModalClose={() => setShowModalEditOccurrence(false)}
        match={dataItemEditOccurrence}
      />
      <ModalAddOccurrence
        showModal={showModalAddOccurrence}
        handleModalClose={() => setShowModalAddOccurrence(false)}
        data={{
          clients: pet ? pet.responsibles : [],
          pets: pet ? [pet._id] : []
        }}
      />
      <TableHeader
        title={'Ocorrências'}
        url={'/occurrences/add'}
        updateList={() => {
          dispatch(getAllOccurrences({ company }));
          dispatch(getAllPets({ company }));
          dispatch(getAllDepartments());
          dispatch(getAllTypeOccurrences({ company }));
          dispatch(getAllClients({ company }));
        }}
        isFetching={occurrences.isFetching}
        hideAddButton={true}
      />
      <Datatable
        data={tableData}
        columns={columns}
        buttons={buttons}
        handleUpdateButton={handleUpdateButton}
        handleDeleteButton={handleDeleteButton}
        handleRestoreButton={handleRestoreButton}
      />
    </div>
  );
}

List.propTypes = {
  pet: PropTypes.object
};

export default List;
